export default [
  {
    name: "Salary Advance",
    icon: "mdi-cash-fast",
    to: "/advance/list",
    enabled: true,
  },
];
